import { render, staticRenderFns } from "./solo-driver-pricing-form.vue?vue&type=template&id=2a72dc59&"
import script from "./solo-driver-pricing-form.vue?vue&type=script&lang=js&"
export * from "./solo-driver-pricing-form.vue?vue&type=script&lang=js&"
import style0 from "./solo-driver-pricing-form.vue?vue&type=style&index=0&id=2a72dc59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports